import { createContext } from 'react';

// Whether team names on screen mark the teams a user manages. The manager
// side's Schedule, Rankings and Postseason pages turn it on; everywhere
// else names show plain.
export const ShowManagersContext = createContext(false);
